import {DisputeResponseDto, DisputeResponseStatus, DisputeStatus} from "@/api/paymentApi";

const DEFENDABLE_STATUSES: ReadonlySet<DisputeStatus> = new Set([
  DisputeStatus.PENDING,
  DisputeStatus.INQUIRY,
  DisputeStatus.REQUESTFORINFORMATION,
  DisputeStatus.NOTIFICATIONOFCHARGEBACK,
]);

export function isAutoDefendedDispute(dispute?: DisputeResponseDto | null): boolean {
  if (!dispute) {
    return false;
  }
  if (dispute.response_status === DisputeResponseStatus.NORESPONSEALLOWED) {
    return true;
  }
  return (dispute.message || '').toLowerCase().includes('automatically defended');
}

export function isDefendableDispute(dispute?: DisputeResponseDto | null): boolean {
  if (!dispute?.status || !DEFENDABLE_STATUSES.has(dispute.status)) {
    return false;
  }
  return !isAutoDefendedDispute(dispute);
}
